
export default {
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getFileName(file_name) {
      const nameParts = file_name.split(".");
      return {
        name: nameParts.splice(0, nameParts.length - 1).join(""),
        ext: nameParts[nameParts.length - 1],
      };
    },
  },
};
